import GroupFormPage from "./group-form-page.jsx";

export default GroupFormPage;